export default function Features() {
  const features = [
    {
      title: 'シルキーな煙',
      description: '滑らかで心地よい煙が、至福のひとときを演出します。',
      icon: 'ri-vip-crown-line',
      image: 'https://public.readdy.ai/ai/img_res/edited_f1ec55bcb92d794024de8e8763bfcac9_b32cba6e.jpg'
    },
    {
      title: 'ジューシーな味わい',
      description: 'ド濃厚でフルーティーな味わいが特徴の、ジューシーな煙をご堪能ください。',
      icon: 'ri-fire-line',
      image: 'https://public.readdy.ai/ai/img_res/6313978fc4def0ba24cb69bc47eaff4e.jpg'
    },
    {
      title: '60分炭替え不要',
      description: '三つの炭で脅威の60分炭変え不要を実現',
      icon: 'ri-quill-pen-line',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20classic%20analog%20clock%20with%20roman%20numerals%20on%20a%20clean%20white%20background%2C%20close-up%20shot%20showing%20detailed%20clock%20face%20with%20golden%20hour%20and%20minute%20hands%2C%20precise%20craftsmanship%2C%20minimalist%20style%2C%20soft%20studio%20lighting%2C%20sharp%20focus%20on%20clock%20details%2C%20luxury%20timepiece%20photography&width=600&height=800&seq=feat003clock&orientation=portrait'
    }
  ];

  return (
    <section id="features" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <h2 className="text-6xl font-bold text-gray-900">三つの極み</h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="group rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              <div className="relative h-80 overflow-hidden">
                <img 
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="bg-white p-8 text-center">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center">
                  <i className={`${feature.icon} text-5xl text-amber-600`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">{feature.title}</h3>
                <p className="text-gray-600 text-base leading-relaxed">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
